import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Transactions made following intentional fault or negligence on your part.',
        ],
        title: 'This warranty does not include',
      },
      include: {
        items: [
          'Coverage of financial losses resulting from the theft of confidential information by malicious third parties engaged in phishing activities;',
          'Losses may include: unauthorized fund transfers, fraudulent transactions, etc.;',
          'Up to a limit of 1,000 € per year.',
        ],
        title: 'This warranty includes',
      },
    },
    similarOffersTitle: 'Related insurances',
    title: 'Phishing',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Les transactions ayant été réalisées suite à une faute intentionnelle ou à une négligence de votre part.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          "La prise en charge des pertes financières résultant du vol d'informations confidentielles par des tiers malveillants engagés dans des activités d’hameçonnage ;",
          'Les pertes peuvent inclure : des transferts non autorisés de fonds, des transactions frauduleuses, etc ;',
          'Dans la limite de 1 000 € par an.',
        ],
        title: 'Cette garantie inclut',
      },
    },
    similarOffersTitle: 'Autres assurances liées',
    title: 'Hameçonnage',
  },
} as const);

export default locales;
